import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-tag-summary',
    templateUrl: './tag-summary.component.html',
    styleUrls: ['./tag-summary.component.scss'],
    standalone: false
})
export class TagSummaryComponent {

  @Input() tag: any;

  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();

  show: boolean = false;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tag']) {
      //this.show = (this.tag !== undefined);

    }
  }

  /**
   * Closes the side panel
   */
  close(): void {
    this.show = !this.show;
  }
  /**
   * Edit the current selected item
   */
  onEditAction() {
    this.onEdit.emit(this.tag);
  }

  /**
   * Delete the currnet selected item.
   */
  onDeleteAction() {
    this.onDelete.emit(this.tag);
  }
}
